import React from "react";

const styles = {
  active: "pill pill-active",
  grace: "pill pill-grace",
  suspended: "pill pill-suspended",
  trial: "pill pill-trial",
  cancelled: "pill pill-cancelled",
  open: "pill pill-open",
  in_progress: "pill pill-in_progress",
  completed: "pill pill-completed",
  reversed: "pill pill-reversed",
};

export const StatusPill = ({ status, testId }) => {
  const cls = styles[status] || "pill";
  return <span data-testid={testId} className={cls}>{status?.replace("_", " ")}</span>;
};

export const StatusBanner = ({ tenant }) => {
  if (!tenant) return null;
  const { status, grace_until, grace_reason, suspended_reason } = tenant;
  if (status === "grace") {
    return (
      <div data-testid="status-banner-grace"
           className="bg-amber-100 border-b-2 border-amber-500 px-4 sm:px-6 py-2 text-sm text-amber-950 flex flex-wrap items-center gap-3 shrink-0">
        <span className="pill pill-grace">Grace period</span>
        <span>
          {grace_reason || "Payment overdue"}
          {grace_until ? ` — please settle by ${grace_until.substring(0,10)}` : ""}
        </span>
      </div>
    );
  }
  if (status === "trial") {
    return (
      <div data-testid="status-banner-trial"
           className="bg-blue-50 border-b-2 border-blue-600 px-4 sm:px-6 py-2 text-sm text-blue-950 flex flex-wrap items-center gap-3 shrink-0">
        <span className="pill pill-trial">Trial</span>
        <span>You are using a trial account.</span>
      </div>
    );
  }
  if (status === "suspended") {
    return (
      <div data-testid="status-banner-suspended"
           className="bg-red-50 border-b-2 border-red-600 px-4 sm:px-6 py-2 text-sm text-red-950 flex flex-wrap items-center gap-3 shrink-0">
        <span className="pill pill-suspended">Suspended</span>
        <span>{suspended_reason || "Account suspended. Contact platform owner."}</span>
      </div>
    );
  }
  return null;
};
